var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { keyframes } from '@emotion/react';
export function overlayEnter() {
    return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "], ["\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  "])));
}
export function overlayExit() {
    return keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    from {\n      opacity: 1;\n    }\n    to {\n      opacity: 0;\n    }\n  "], ["\n    from {\n      opacity: 1;\n    }\n    to {\n      opacity: 0;\n    }\n  "])));
}
var templateObject_1, templateObject_2;
